<script setup lang="ts">
import { type ContentPageContentModel } from '~/types/contentapi';
import type { ContentResponseWithAncestors } from '~/server/types';

const { userData } = useAuth();

const props = defineProps<ContentResponseWithAncestors<ContentPageContentModel>>();

const dealerDenyList: string[] = (userData.value?.dealers[0].denyListProductClassifications || []).map(item =>
  item.toLowerCase()
);

// Check if any values match between the two deny lists
const contentPageNotPermitted = computed(() => {
  const contentDenyList = (props.properties?.denyListProductClassifications || []).map((item: string) =>
    item.toLowerCase()
  );
  return contentDenyList.some((item: string) => dealerDenyList.includes(item));
});

// Show 404 if there's a match
if (contentPageNotPermitted.value) {
  throw createError({ statusCode: 404, message: 'Page not found' });
}

const components = computed(() => props.properties?.components?.items || []);
</script>

<template>
  <div class="overflow-hidden">
    <ComponentRenderer v-if="components && components.length > 0" :components />
  </div>
</template>

<style scoped></style>
